import { Button, DatePicker, Form, Radio, Select } from "antd";
import React, { useEffect, useState } from "react";
import { filterOption, requiredField } from "../common/common";
import { UploadOutlined } from "@ant-design/icons";
import axiosInstance from "../common/api";
import { useNavigate } from "react-router";
import Dragger from "antd/lib/upload/Dragger";
import FormPage from "../common/FormPage";

export default function NewAppointment() {
  const [employees, setEmployees] = useState([]);
  const [appointmentTypes, setAppointmentTypes] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    [
      { u: "appointmentType", f: setAppointmentTypes},
      { u: "employee", f: setEmployees },
    ].forEach((x) => {
      axiosInstance.get(x.u,{params:{pageSize:99999}}).then(({ data }) => x.f(data.data));
    });
  }, []);


  const onFormFinish = (form) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("employee", form.employee);
    formData.append("type", form.type);
    formData.append("date", form.date.format("YYYY-MM-DD"));
    formData.append("file", form.file.file);
    axiosInstance
      .post("appointment", formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then(() => navigate(-1));
  };
  return (
    <FormPage
      title="Carica nuova nomina"
      onFinish={onFormFinish}
      initialValues={{ isBase: false }}
    >
      <Form.Item name="employee" label="Dipendente" rules={[requiredField]}>
        <Select
          filterOption={filterOption}
          showSearch
          placeholder="Seleziona il dipendente"
          options={employees.map((x) => ({ label: x.fullName, value: x.id }))}
        />
      </Form.Item>
      <Form.Item name="type" label={"Categoria"} rules={[requiredField]}>
        <Select
          filterOption={filterOption}
          showSearch
          placeholder={"Seleziona il tipo di corso"}
          options={appointmentTypes.map((x) => ({ label: x.name, value: x.id }))}
        />
      </Form.Item>
      <Form.Item name="date" label={"Data"} rules={[requiredField]}>
        <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item label={"File"} name="file" valuePropName={"file"} rules={[requiredField]}>
        <Dragger accept={"application/pdf"} maxCount={1} beforeUpload={() => false}>
          <p>Trascina qui il file (Solo .pdf accettati)</p>
          <Button icon={<UploadOutlined />}>Seleziona file</Button>
        </Dragger>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "end" }}>
        <Button htmlType={"submit"} type={"primary"} loading={loading}>
          Carica
        </Button>
      </Form.Item>
    </FormPage>
  );
}
